module.exports = __webpack_public_path__ + "static/media/nh-icon-digital-transformation.69848ae7.png";